import { ParentFolderProps } from '@lib/common';
import { ParentFolder, SpaceObjects } from '@module/form';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'next-i18next';
import { spaceObjectsSelector } from 'redux/space';

export const useBreadcrumbFolders = (): ParentFolderProps[] => {
  const { t: translation } = useTranslation();
  const spaceObjects: SpaceObjects = useSelector(spaceObjectsSelector);

  return useMemo(() => {
    if (!spaceObjects) {
      return [{ id: 'home', title: translation('workspace') }];
    }

    const { parentFolders } = spaceObjects;
    return parentFolders.map((parentFolder: ParentFolder) => {
      const isRoot = parentFolder.title === 'Home';
      if (isRoot) {
        return { id: 'home', title: translation('workspace') };
      }
      return {
        id: parentFolder.id.toString(),
        title: parentFolder.title,
      };
    });
  }, [translation, spaceObjects]);
};
